// #1 Initial state
const initialState = {}

// #2 Possible fixed Actions on the state
function setMenus(value) {
  return {
    type: 'SET_MENUS',
    payload: value,
  }
}

// #3 Dispatch above actions with the help of reducers
function menuReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_MENUS':
      return action?.payload

    default:
      return state
  }
}

export default {
  initialState,
  actions: { setMenus },
  reducer: menuReducer,
}
